var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[(_vm.filteredModeratedMessages.length == 0)?_c('li',[_c('p',[_vm._v("There's nothing here!")])]):_vm._e(),_vm._l((_vm.filteredModeratedMessages),function(moderatedMessage){return _c('ModeratedMessage',{key:moderatedMessage.msg.hash,staticClass:"moderatedMessage",attrs:{"token":_vm.token,"moderatedMessage":moderatedMessage,"selectedRoomName":_vm.selectedRoomName,"selectedState":_vm.selectedState,"disabled":_vm.disabled},on:{"changeState":newState => {
        moderatedMessage.State = newState;
        _vm.$emit('refresh');
      }}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }